import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { LoginService } from './services/auth.service';
import { GeneralService } from './services/general.service';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'MatesRide';
  year: any;

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  public ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      const bases = this.document.getElementsByTagName('base');

      if (bases.length > 0) {
        bases[0].setAttribute('href', environment.baseHref);
      }
    }
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private document: any,
    public loginService: LoginService,
    public generalService: GeneralService,
    public router: Router,
    public dialog: MatDialog,
    public iconRegistry: MatIconRegistry,
    public sanitizer: DomSanitizer
  ) {
    this.year = new Date().getFullYear();
    this.registerCustomIcons();
  }

  onDeactivate() {
    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  registerCustomIcons() {
    // createRide
    this.iconRegistry
      .addSvgIcon(
        'viewRides',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/viewRides.svg')
      )
      .addSvgIcon(
        'travelStories',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/travelStories.svg')
      ).addSvgIcon(
        'rideshare',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/rideshare.svg')
      ).addSvgIcon(
        'liftCar',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/liftCar.svg')
      ).addSvgIcon(
        'lift',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/lift.svg')
      ).addSvgIcon(
        'friend',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/friend.svg')
      )
      .addSvgIcon(
        'notfound',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/notfound.svg')
      )
      .addSvgIcon(
        'createTrip',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/createTrip.svg')
      )
      .addSvgIcon(
        'createRide',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/createRide.svg')
      )
      .addSvgIcon(
        'searchRides',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/searchRides.svg')
      )
      .addSvgIcon(
        'dashboard',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/dashboard.svg')
      )
      .addSvgIcon(
        'chat',
        this.sanitizer.bypassSecurityTrustResourceUrl('/assets/chat.svg')
      );
  }
}
